// 発送元が違う商品をカートに入れて購入手続きボタンを押したときにアラートを出す
$(function() {
  $('.cart__checkout-button').attr('type', 'button');
  var producer_array = [];
  var producer_result_array = [];
  $('.product_vendor').each(function() {
    var product_vendor_text = $(this).text(); //発送元
    var producer_result = $.inArray(product_vendor_text, producer_array); //発送元が配列内にあるか
    producer_result_array.push(producer_result); //発送元が配列内にあるかの結果を配列に追加
    producer_array.push(product_vendor_text); //発送元を配列に追加
  });
  producer_result_array.shift(); //配列内の0番目の値を削除

  var alert_result = $.inArray(-1, producer_result_array);
  if(alert_result !== -1) {
    $('.cart__checkout-button').attr('type', 'button');
  } else {
    $('.cart__checkout-button').attr('type', 'submit');
  }
  
  $('.cart__checkout-button').click(function() {
    console.log($('.cart__checkout-button').attr('type'));
    button_type = $('.cart__checkout-button').attr('type');
    if(alert_result !== -1 && button_type === 'button') {
      $('.alert_wrap').show();
      $('body').addClass('alert_show');
    }
  });

  $('.alert_close').click(function() {
    $('.alert_wrap').hide();
		$('body').removeClass('alert_show');
	});
});

// 監視ターゲットの取得
const target = document.getElementById('cart-live-region-text');
// オブザーバーの作成
const observer = new MutationObserver(function() {
  // 変化が発生したときの処理を記述
  $('.cart__checkout-button').attr('type', 'button');
  var producer_array = [];
  var producer_result_array = [];
  $('.product_vendor').each(function() {
    var product_vendor_text = $(this).text(); //発送元
    var producer_result = $.inArray(product_vendor_text, producer_array); //発送元が配列内にあるか
    producer_result_array.push(producer_result); //発送元が配列内にあるかの結果を配列に追加
    producer_array.push(product_vendor_text); //発送元を配列に追加
  });
  producer_result_array.shift(); //配列内の0番目の値を削除

  var alert_result = $.inArray(-1, producer_result_array);
  if(alert_result !== -1) {
    $('.cart__checkout-button').attr('type', 'button');
  } else {
    $('.cart__checkout-button').attr('type', 'submit');
  }
})

const config = { childList: true }; // 監視を指定するオプション
observer.observe(target, config); // 監視開始
